import React, { useState, useEffect } from 'react'
import { useTypedSelector } from 'src/redux/index'
import { PlanTypes } from 'src/redux/types/planTypes'
import { Link, useLocation, useParams } from 'react-router-dom'
import { JoinContestWrapper, Progress } from './style'
import { addNairaSign } from 'src/utils/addNairaSign'
import {
  ModalButton,
  CreateButton,
  DeleteContestBtn,
} from 'src/components/Global/Button/Button'
import { joinedContestNav } from './contestOption'
import { useDispatch } from 'react-redux'
import { action } from 'typesafe-actions'
import WithdrawalModal from '../../../HomePage/ModalsContent/Withdrawal/WithdrawalModal'

const JoinedContestDetail = () => {
  const params = useParams()
  const { id } = params
  const userContest = useTypedSelector((state) => state.xcontest.userContests)

  const data = userContest.filter((item: any) => item?.contest_id === id)

  console.log(data)

  const {
    contest_id,
    contest_name,
    amount_to_save,
    plan,
    saving_freqency,
    end_date,
  } = data[0]
  const paymentData = {
    id: plan['id'],
    saving_into: contest_name,
  }
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, paymentData))
  }, [dispatch])
  const maturityDate = new Date(end_date).toDateString()
  let location = useLocation()

  const { progress, can_withdraw, can_delete } = plan

  console.log(can_delete)

  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false)

  const handleWithdrawalModal = () => {
    setShowWithdrawalModal(!showWithdrawalModal)
  }

  const type: any = 'investment' || 'plan'

  return (
    <JoinContestWrapper>
      <div className="withdraw_component">
        {/* {can_withdraw ? <CreateButton>Withdraw</CreateButton> : ''} */}
        <CreateButton
          onClick={handleWithdrawalModal}
          className={can_withdraw ? '' : 'opacity'}
        >
          Withdraw
        </CreateButton>
      </div>

      {/* withdraw component */}
      <WithdrawalModal
        showWithdrawalModal={showWithdrawalModal}
        setShowWithdrawalModal={setShowWithdrawalModal}
        plan={plan}
        type={type}
      />
      {/* withdraw component */}

      <div className="header">
        <h2 className="name">{contest_name}</h2>
      </div>

      <div className="progress">
        <div className="progress-bar">
          <Progress width={progress >= '100' ? '100%' : `${progress}%`} />
        </div>
        <div className="amount">
          <p className="amount_to_save">{addNairaSign(amount_to_save)} Saved</p>
          <p className="progress_number">{progress} Days</p>
        </div>
      </div>

      {/* <div className="other_details">
        <div className="flex_one">
          <p>Amount being saved</p>
          <p>Saving Frequency</p>
          <p>End date</p>
        </div>
        <div className="flex_two">
          <p>{addNairaSign(amount_to_save)}</p>
          <p>{saving_freqency}</p>
          <p>{maturityDate}</p>
        </div>
      </div> */}

      <div className="menu_container">
        {joinedContestNav.map((item: any, index: number) => {
          const { ArrowRight, Svg, title, description, path } = item
          return (
            <Link
              to={`${path}/${contest_id}`}
              key={index}
              className="joined_contest_link"
              state={{ backgroundLocation: location }}
            >
              <div className="menu_item">
                <div className="left">
                  <img src={Svg} alt="" />
                  <div className="text">
                    <p className="title">{title}</p>
                    <p className="description">{description}</p>
                  </div>
                </div>
                <div className="right">
                  <ArrowRight className="arrow" />
                </div>
              </div>
            </Link>
          )
        })}
      </div>

      <div className="delete_contest_wrapper">
        <DeleteContestBtn className={can_delete ? '' : 'opacity'}>
          Delete
        </DeleteContestBtn>
      </div>

      <div className="top_up_container">
        <Link
          to={`/contest-payment-amount`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="top_up_btn">Top up</ModalButton>
        </Link>
      </div>
    </JoinContestWrapper>
  )
}

export default JoinedContestDetail
